import toast from "react-hot-toast";

const isEmptyValue = (input, value) => {
    const valueType = typeof value;

    return (valueType === 'string' && !value?.trim())
        || (input.type === 'file' && !Array.isArray(value) && !value?.titulo)
        || (valueType === 'number' && !Boolean(value) && value !== 0)
        || (Array.isArray(value) && value.length === 0)
        || (valueType === 'object' && !Array.isArray(value) && !Boolean(value))
        || (valueType === 'undefined');
};

export const validateStepFields = ({ formattedInputs = [], formattedGroups = [], formData = {} }) => {


    const missingFields = [];

    if (formattedInputs.length) {
        formattedInputs.forEach(field => {
            if (!field.disabled && !field.hidden && field.required && isEmptyValue(field, formData?.[field.name])) {
                missingFields.push(field.displayName || field.name);
            }
        });
    }

    if (formattedGroups.length) {
        formattedGroups.forEach(group => {
            const groupHidden = group.hidden;
            const inputs = group.inputs || [];

            inputs.forEach(field => {
                const isVisible = !field.hidden && !groupHidden;
                const isRequired = !!field.required && !groupHidden;
                const onlyWhenValue = field.onlyWhen?.value;
                const onlyeWhenField = field.onlyWhen?.field;


                if (isVisible && isRequired && isEmptyValue(field, formData?.[field.name])) {
                    missingFields.push(field.displayName || field.name);
                }

                if (onlyWhenValue != undefined && onlyeWhenField){
                    if (isVisible && isRequired && !formData?.[field.name] && onlyWhenValue == formData?.[onlyeWhenField]) {
                        missingFields.push(field.displayName || field.name);
                    } 
                }               
            });
        });
    }

    if (missingFields.length > 0) {
        if (missingFields.length >= 5) {
            toast.error(`Faltan completar ${missingFields.length} campos requeridos (*)`);
        } else {
            toast.error(`Los siguientes campos son requeridos: ${missingFields.join(', ')}`);
        }
        const error = new Error("Validación fallida");
        error.isValidationError = true; // <-- Marcamos que es validación
        throw error; // <-- Cortamos el flujo
    }
};